import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import IconCircleAlert from 'components/icons/circle-alert';

const Container = styled.div`
  cursor: pointer;
  padding: 0;
  margin-left: 10px;
  display: flex;
  align-items: center;
  svg {
    width: 16px;
    min-width: 16px;
  }
`;

const Icon = styled(IconCircleAlert)`
  fill: ${Styles.color.red};
`;

const Message = styled.div`
  font-size: 12px;
  display: inline;
  margin-left: 4px;
  color: ${Styles.color.red};
  text-decoration: underline;
  font-weight: bold;
`;

interface IUnverifiedMethodProps {
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

export const UnverifiedMethod: React.FC<IUnverifiedMethodProps> = ({ onClick }) => {
  const { formatMessage } = useIntl();
  return (
    <Container data-testid="unverified-method-badge" onClick={onClick}>
      <Icon />
      <Message>{formatMessage({ id: 'unverified' })}</Message>
    </Container>
  );
};
